import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('intelligentOutboundCallModelStore')
@observer
class IntelligentOutboundCallModel extends Component {
  render() {
    const { intelligentOutboundCallModelStore, location } = this.props
    const { isFetching } = intelligentOutboundCallModelStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm location={location} />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default IntelligentOutboundCallModel;
